SC.careers = (function () {
  var api = {};

  var init = function () {
    setEvents();
  };

  var setEvents = function () {
    // toggle filters
    $('.filter-header').click(function () {
      $('.filters').toggleClass('block');
    });

    // toggle active state, update filter header
    $('.filter').click(function () {
      var $selectedFilter = $(this);
      var $filterTitle = $('.filter-title');
      var $allCareers = $('.careers-by-region');
      var $selectedCareers = $('.careers-list').find('[data-region="' + $selectedFilter.text() + '"]');

      // toggle active state
      $('.filter').removeClass('active');
      $selectedFilter.addClass('active');

      // filter careers based on selection
      $allCareers.removeClass('selected');
      if ($selectedFilter.hasClass('all')) {
        $allCareers.addClass('selected');
      } else {
        $selectedCareers.addClass('selected');
      }

      // update filter header
      $filterTitle.text($selectedFilter.text());

      // toggle filter container
      $('.filters').toggleClass('block');
    });
  };

  init();
  return api;
})();
